import React from 'react'
import { connect } from 'react-redux'
import { selectors as authSelectors } from '@hixme/auth-ui'
import { createErrorNotification } from 'modules/notification-manager/actions'
import * as userSessionSelectors from 'store/modules/user-session/selectors'
import { useBridgeTransfer } from 'hooks/useBridgeTransfer'
import InfoCard from '../InfoCard/InfoCard'
import QLEImage from '../assets/QLEImage.png'
import useFeatureFlags from 'hooks/useFeatureFlags'

type QLEV2CardViewProps = {
  idToken: string
  employeePublicKey: string
  isImpersonated: boolean
  clientPublicKey: string
  qleGroupNo: string
  onError: (message: string) => void
}

const QLEV2CardView = ({
  idToken,
  employeePublicKey,
  isImpersonated,
  clientPublicKey,
  qleGroupNo,
  onError,
}: QLEV2CardViewProps) => {
  const { handleQLEBridgeTransfer, isTransferring } = useBridgeTransfer({
    idToken,
    employeePublicKey,
    isImpersonated,
    clientPublicKey,
    onError,
  })

  return (
    <InfoCard
      Image={QLEImage}
      title="My Qualifying Life Events"
      message={'Manage your life events'}
      state="start"
      buttonLabel={isTransferring ? 'Loading...' : 'Start'}
      onClick={() => handleQLEBridgeTransfer(qleGroupNo)}
    />
  )
}

type QLEV2CardProps = QLEV2CardViewProps & {
  isInQleV2Period?: boolean
  isPausedForActor?: boolean
}

export const QLEV2Card = ({ isPausedForActor, ...rest }: QLEV2CardProps) => {
  const { flags } = useFeatureFlags()
  const isImpersonated = rest.isImpersonated
  const isQLEV2AllowImpersonation = flags?.['enrollme.qle-v-2-allow-impersonation']
  // A paused enrollment freezes all shopping, including QLE — hide the QLE bridge entry point.
  if (isPausedForActor || !flags['enrollme.qle-v-2'] || (isImpersonated && !isQLEV2AllowImpersonation)) {
    return null
  }

  return <QLEV2CardView {...rest} />
}

const mapStateToProps = (state: any) => {
  const credentials = authSelectors.getCredentials(state || {})
  return {
    idToken: credentials?.idToken || '',
    employeePublicKey: userSessionSelectors.getUserId(state) || '',
    isImpersonated: userSessionSelectors.isImpersonating(state),
    clientPublicKey: userSessionSelectors.getClientPublicKey(state) || '',
    qleGroupNo: userSessionSelectors.getQleGroupNo(state) || '',
    isPausedForActor: userSessionSelectors.getIsPausedForActor(state),
  }
}

const mapDispatchToProps = (dispatch: any) => ({
  onError: (message: string) => dispatch(createErrorNotification(message)),
})

export default connect(mapStateToProps, mapDispatchToProps)(QLEV2Card)
